import { MailingAddressFields } from './MailingAddressFields';
import { Checkbox } from '@servicetitan/anvil2-react-hook-form';
import { createSchema } from './schema';
import { ApplicationData, ApplicationDataStore } from '../application/ApplicationDataStore';
import { SaveFormDataToStore } from '../application/SaveFormDataToStore';
import { Form, FormProps } from '../common/Form';
import { SpouseFormFields } from '../spouseInfo';
import { useMemo } from 'react';
import { StateFieldWatcher } from './StateFieldWatcher';

export const Container = (
    props: Omit<
        FormProps<ApplicationData['mailingAddress']>,
        'schema' | 'defaultValues' | 'formData' | 'children'
    >,
) => {
    const { applicationData } = ApplicationDataStore.useStore();
    const schema = useMemo(() => createSchema(), []);

    return (
        <Form {...props} formData={applicationData.mailingAddress!} schema={schema}>
            <SaveFormDataToStore fieldPrefix="mailingAddress" />
            <MailingAddressFields fieldPrefix="primaryApplicant" />
            <Checkbox
                label="Work is being performed at this address"
                name="workPerformedAtAddress"
            />
            {/* Watch state inside Form context to determine what spouse information we need to gather */}
            <StateFieldWatcher fieldPrefix="primaryApplicant">
                {(state: string) => (
                    <SpouseFormFields
                        applicantType="primary"
                        state={state}
                        context="mailing-address"
                    />
                )}
            </StateFieldWatcher>
        </Form>
    );
};
